// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardid[data-v-4f03dbb8]{font-size:.9em}`, "",{"version":3,"sources":["webpack://./src/components/cards/badges/CardId.vue"],"names":[],"mappings":"AACA,yBACC,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
